<template>
  <v-nav>
    <div style="width: 100%;margin-top: 20px;background-color: #e8e8e8;padding: 16px 16px;color: black">
      <a-page-header
          style="border: 1px solid rgb(235, 237, 240);background-color: white"
          :title="title"
      >
        <a-descriptions class="cibr-self">
          <a-descriptions-item :label="$t('time')" style="color: black">
            <a-radio-group v-model:value="time" button-style="solid" @change="initPage">
              <a-radio-button value="all">{{ $t("all") }}</a-radio-button>
              <a-radio-button value="today">{{ $t("today") }}</a-radio-button>
              <a-radio-button value="seven">{{ $t("seven") }}</a-radio-button>
              <a-radio-button value="month">{{ $t("month") }}</a-radio-button>
            </a-radio-group>
          </a-descriptions-item>
        </a-descriptions>
        <a-statistic title="Total visits" :value="totalVisit" style="margin-right: 50px;display: inline-block" />
        <a-statistic title="Total download" :value="totalDownload" style="margin-right: 50px;display: inline-block" />
      </a-page-header>
      <div style="width: 100%;text-align: center;">
        <div id="visitMap" style="width: 100%;height: 500px;display: inline-block;border-radius: 20px"></div>
      </div>
      <a-table :columns="cols" :data-source="mapList" :pagination="false">
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'index'">
            {{ index + 1 }}
          </template>
          <template v-if="column.key === 'city'">
            {{ record.name }}
          </template>
          <template v-if="column.key === 'visit'">
            {{ record.value[2] }}
          </template>
          <template v-if="column.key === 'download'">
            {{ record.value[3] }}
          </template>
        </template>
      </a-table>
    </div>
  </v-nav>
</template>

<script>
import "echarts/extension/bmap/bmap";
import VNav from "@/components/public/VNav.vue";
import util from "@/util/util";
import * as echarts from 'echarts';
import dayjs from "dayjs";
export default {
  name: "visitPage",
  components: {VNav},
  data: function () {
    return {
      mapList: [],
      totalVisit: 0,
      totalDownload: 0,
      time : "all",
      cols : [
        {
          title: '#',
          dataIndex: 'index',
          key: 'index',
          width : 70
        },
        {
          title: this.$t("city"),
          dataIndex: 'city',
          key: 'city',
        },
        {
          title: this.$t("totalVisits"),
          dataIndex: 'visit',
          key: 'visit',
        },
        {
          title: this.$t("totalDownload"),
          dataIndex: 'download',
          key: 'download',
        },
      ],
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      var that = this;
      var post = {
        time : this.time
      }
      util.$post("/map/getData", post,(res)=>{
        that.mapList = res.mapList;
        that.totalVisit = res.totalVisit;
        that.totalDownload = res.totalDownload;
        that.drawMap();
      })
    },
    getBaseLog(x, y) {
      return Math.log(y) / Math.log(x);
    },
    drawMap() {
      // var that = this;
      var option = {
        title: {
          // text: 'Visits and download statistics',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        bmap: {
          center: [90.97, 29.71],
          zoom: 1,
          roam: true,
          mapStyle: {
            styleJson: [
              {
                featureType: 'water',
                elementType: 'all',
                stylers: {
                  color: '#d1d1d1'
                }
              },
              {
                featureType: 'land',
                elementType: 'all',
                stylers: {
                  color: '#f3f3f3'
                }
              },
              {
                featureType: 'railway',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'highway',
                elementType: 'all',
                stylers: {
                  color: '#fdfdfd'
                }
              },
              {
                featureType: 'highway',
                elementType: 'labels',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'arterial',
                elementType: 'geometry',
                stylers: {
                  color: '#fefefe'
                }
              },
              {
                featureType: 'arterial',
                elementType: 'geometry.fill',
                stylers: {
                  color: '#fefefe'
                }
              },
              {
                featureType: 'poi',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'green',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'subway',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'manmade',
                elementType: 'all',
                stylers: {
                  color: '#d1d1d1'
                }
              },
              {
                featureType: 'local',
                elementType: 'all',
                stylers: {
                  color: '#d1d1d1'
                }
              },
              {
                featureType: 'arterial',
                elementType: 'labels',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'boundary',
                elementType: 'all',
                stylers: {
                  color: '#fefefe'
                }
              },
              {
                featureType: 'building',
                elementType: 'all',
                stylers: {
                  color: '#d1d1d1'
                }
              },
              {
                featureType: 'label',
                elementType: 'labels.text.fill',
                stylers: {
                  color: '#999999'
                }
              }
            ]
          }
        },
        series: [
          {
            name: "Visits and download",
            type: 'effectScatter',
            coordinateSystem: 'bmap',
            data: this.mapList,
            symbolSize: function (val) {
              return Math.log((parseFloat(val[2]) + parseFloat(val[3])) * 100) * 2;
            },
            encode: {
              tooltip: [2, 3],
            },
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke'
            },
            label: {
              formatter: '{b} : Visits:{@[2]}  Download:{@[3]}',
              position: 'right',
              show: false
            },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: '#333'
            },
            emphasis: {
              scale: true,
              label: {
                show: true
              }
            },
          },
        ]
      };
      var visitMap = echarts.init(document.getElementById('visitMap'));
      visitMap.setOption(option);
      window.onresize = function () {
        this.initPage();
      }
    }
  },
  computed:{
    title(){
      return this.$t("visitStatistic") + "(" + dayjs().format("YYYY-MM-DD HH:mm") + ")"
    }
  }
}
</script>

<style scoped>
.BMap_cpyCtrl {

  display: none !important;

}

.anchorBL {

  display: none !important;

}
</style>